import { type AlertProps, AlertTitle, Box, IconButton } from '@lingoda/ui';
import { ConfettiIcon, XIcon } from '@lingoda/ui/icons/lingodaIcons';

interface Props {
    onClose?: AlertProps['onClose'];
    title: string;
}

export const Header = ({ onClose, title }: Props) => {
    return (
        <AlertTitle>
            <Box display="flex" alignItems="center">
                <Box sx={{ marginRight: 1.5, display: 'inline-flex' }}>
                    <ConfettiIcon size={24} />
                </Box>
                <Box flex="1 1 auto">{title}</Box>
                {onClose && (
                    <IconButton
                        sx={{
                            color: 'text.secondary',
                            padding: 0.5,
                        }}
                        onClick={onClose}
                    >
                        <XIcon size={20} />
                    </IconButton>
                )}
            </Box>
        </AlertTitle>
    );
};
